class QueryStringParser {
    parse(queryString){
        var termNames = {}

        var query = queryString.substring(1);
        var vars = query.split('&');
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split('=');
            if (decodeURIComponent(pair[0]) === 'f') {
                termNames.first = decodeURIComponent(pair[1]);
            }
            if (decodeURIComponent(pair[0]) === 's') {
                termNames.second = decodeURIComponent(pair[1]);
            }
        }
        return termNames;
    }
}

export default QueryStringParser;


// WEBPACK FOOTER //
// ./src/components/game/queryStringParser.js